/**
 * menu panelu aplikacji po zalogowaniu się
 */

export default []
